import spPriorityCommentDialogTemplate from './spPriorityCommentDialog.html';
import spPriorityCommentTemplate from './spPriorityCommentForm.html';

angular
   .module('org.saga.spprioritycomment', [
      'org.saga.service',
      'org.saga.spcosts',
      'isolateForm'
   ])
   .directive('sppriorityComment', [
      function () {
         return {
            restrict: 'E',
            template: spPriorityCommentTemplate,
            scope: {
               comment: '=',
               configuration: '=',
               newCommentForm: '=',
               editable: '=?'
            },
            controller: [
               '$scope',
               function ($scope) {
                  $scope.commentSeverity = [
                  {value: 'RECOMMENDED', label: 'Doporučená'},
                  {value: 'FORMAL', label: 'Formální'},
                  {value: 'MAJOR', label: 'Zásadní'},
               ]
               }
            ]
         };
      }
   ])

   .factory('SpPriorityCommentDialog', [
      '$mdDialog',
      '$log',
      function ($mdDialog) {
         return {
            show: function (
               priority,
               comment,
               configuration,
               callback,
               activity,
               budgetItem
            ) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.priority = priority;
                  $scope.comment = comment;
                  $scope.configuration = configuration;
                  $scope.activity = activity;
                  $scope.budgetItem = budgetItem;
                  $scope.costs = [budgetItem];

                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  $scope.ok = function () {
                        $mdDialog.hide($scope.comment);
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: spPriorityCommentDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);
